import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { GAME_LAUNCH_EVENT, GAME_PLAYER_PATH } from "../../../lib/gameLaunch";

const GameLaunchNavigator = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleGameLaunch = (event) => {
      event.preventDefault();
      navigate(GAME_PLAYER_PATH);
    };

    window.addEventListener(GAME_LAUNCH_EVENT, handleGameLaunch);
    return () => window.removeEventListener(GAME_LAUNCH_EVENT, handleGameLaunch);
  }, [navigate]);

  return null;
};

export default GameLaunchNavigator;
